var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.user && _vm.currentPageName !== 'Login')?_c('nav-bar'):_vm._e(),(_vm.user && _vm.currentPageName !== 'Login')?_c('aside-menu',{attrs:{"site-name":_vm.sitename,"menu":_vm.menu},on:{"menu-click":_vm.menuClick}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }